import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import PageTabHeader from "@/App/Layouts/PageBody/PageTabHeader";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import { ViewLayout } from "@/App/Layouts/ViewLayout";
import NoDataAlert from "@/common/components/AppAlerts/NoDataAlert";
import AssetSpecDisplay from "@/common/components/Entity/Asset/AssetSpecDisplay";
import { ViewVariant } from "@/common/ts/layout";
import { AssetDto } from "@/core/api/generated/v1";

interface Props {
  asset: AssetDto;
}

export default function SpecTabContent({ asset }: Props) {
  return (
    <PageTabContent>
      <ViewLayout
        displayProps={{ viewVariant: ViewVariant.Tab }}
        header={<PageTabHeader title={"Spec"} />}
      >
        <ViewContentBlock>
          {!asset?.spec && <NoDataAlert />}

          <AssetSpecDisplay tenantId={asset?.tenantId} spec={asset?.spec} />
        </ViewContentBlock>
      </ViewLayout>
    </PageTabContent>
  );
}
